import { FC } from 'react';
import { Box } from '@mui/material';
import { Form, FormDatePicker, FormRow } from '@chargeafter/forms';
import { FormDatePickerProps } from '@chargeafter/forms/src/lib/components/FormDatePicker/FormDatePicker';
import { secureHttpClient } from '../restClient';
import { ModalHeader } from './ModalHeader';
import { AppView } from '../constants';
import { useConfirm } from '../services/confirmationModalManager';

type Promotion = {
  id: string;
  type: string;
  description: string;
  code: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
  data: { fundingDate: string };
};

const useGetPromotionCode = () => {
  const promoConfirmation = useConfirm(AppView.PromotionCodeModal);
  return async (consumerName: string, fromPending: boolean) => {
    if (fromPending) return;
    const { promotions } = await secureHttpClient.getOperate<{
      promotions: Promotion[];
    }>(
      {
        fetchingFunction: 'useCheckout',
        fileName: 'flowManager',
      },
      'api/merchants/promotions?active=true',
    );
    if (!promotions.length) return;
    try {
      await promoConfirmation({
        allowClose: true,
        title: <ModalHeader title={`Enable pre-sale for ${consumerName}`} />,
        confirmationText: 'Confirm',
        cancellationText: 'Continue Without',
        description: (
          <PreSaleForm
            startDate={promotions[0].startDate}
            endDate={promotions[0].endDate}
            additionalData={promotions[0].data}
          />
        ),
      });
      return promotions[0].code;
    } catch (e) {
      return '';
    }
  };
};

export default useGetPromotionCode;

const AdjustedFormPicker: FC<FormDatePickerProps> = (props) => {
  return (
    <FormDatePicker
      {...props}
      InputProps={{
        sx: {
          button: {
            display: 'none',
          },
        },
      }}
      disabled
      shouldBeHidden={false}
    />
  );
};

type PreSaleFormProps = {
  startDate: string;
  endDate: string;
  additionalData: { fundingDate: string };
};

const PreSaleForm: FC<PreSaleFormProps> = ({
  startDate,
  endDate,
  additionalData,
}) => {
  const { fundingDate } = additionalData;
  return (
    <Box padding={5}>
      <Form
        onSubmit={() => undefined}
        initialValues={{
          startDate,
          endDate,
          fundingDate,
        }}
        render={() => (
          <FormRow>
            <AdjustedFormPicker label="Pre-Sale start date" name="startDate" />
            <AdjustedFormPicker label="Pre-Sale end date" name="endDate" />
            <AdjustedFormPicker
              label="Pre-Sale settle date"
              name="fundingDate"
            />
          </FormRow>
        )}
      />
    </Box>
  );
};
